const CheckMarkIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="7"
      height="6"
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.63887 0.674475L6.33169 0.365485C6.20513 0.238198 5.99855 0.238198 5.8709 0.365485L2.64983 3.60662L0.962487 1.90935C0.835944 1.78205 0.629346 1.78205 0.501714 1.90935L0.194517 2.21834C0.0679735 2.34564 0.0679735 2.55344 0.194517 2.68182L2.41836 4.91873C2.48218 4.98293 2.56437 5.01557 2.64766 5.01557C2.73096 5.01557 2.81424 4.98293 2.87698 4.91873L6.63562 1.13797C6.76542 1.00851 6.76542 0.801791 6.63887 0.674475Z"
        fill="white"
      />
    </svg>
  );
};

export default CheckMarkIcon;
